import { render } from "./InvoiceEdit.vue?vue&type=template&id=1bdb1aed&ts=true"
import script from "./InvoiceEdit.vue?vue&type=script&lang=ts"
export * from "./InvoiceEdit.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__